import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";

const CopyCell = ({ value }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success("Copied");
  };

  return (
    <div style={copyCell}>
      <span style={copyCellText}>{value}</span>

      <MdContentCopy style={CopyIcon} onClick={handleCopy} />
    </div>
  );
};

const copyCell = {
  display: "flex",
  alignItems: "center",
  gap: "2px",
};

const copyCellText = {
  whiteSpace: "normal",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

const CopyIcon = { 
  cursor: "pointer",
  flexShrink: 0,
}
export default CopyCell;
